import Utils from 'src/utils/Utils';
import DeviceStorage from '../components/DeviceStorage/DeviceStorage';
import Device from "../devices/device";

const defaultAppKey = "531eed59e4b050ea818ae755";

const getDeviceID=()=>{
  const device_config = Device.getDevice().getConfig();
  if(device_config.device_id) {
    DeviceStorage.setItem('__UUID__', device_config.device_id);
  }
  let Id = DeviceStorage.getItem('__UUID__');
  if (Id) {
    return Id;
  }
  let random=null;
  Id = "";
  for (let i = 0; i < 32; i++) {
    random = Math.random() * 16 | 0;

    if (i === 8 || i === 12 || i === 16 || i === 20) {
      Id += "-";
    }
    Id += (random).toString(16);
  }
  DeviceStorage.setItem('__UUID__', Id);
  return Id;
}



function getAppConfig() {
  const device_config = Device.getDevice().getConfig();

  const dev_id = getDeviceID();
  
  let end_point_middleware= window.location.origin ? `${window.location.origin}/webapi-video/` :
  window.location.host ? `${window.location.protocol}//${window.location.host}/webapi-video/` :
    `${window.location.protocol}//${window.location.hostname}/webapi-video/`;

  //let end_point_middleware=process.env.NODE_ENV !== 'production'? `http://aaf-stbnagra-${(env=='test')?env:'preprod'}.clarovideo.net/webapi-video/`:'/webapi-video/';
  const MUSIC_MIDDLEWARE_URI_OTT = process.env.MUSIC_MIDDLEWARE_URI_OTT || "http://mw-cglobal-cvideo-web.clarovideo.net";
  const MUSIC_MIDDLEWARE_URI_STB = process.env.MUSIC_MIDDLEWARE_URI || "http://mw-cglobal-cvideo-stb.clarovideo.net";
  const musicMiddlewareEndpoint =  device_config.device_category === "stb" ? MUSIC_MIDDLEWARE_URI_STB : MUSIC_MIDDLEWARE_URI_OTT;
  //let end_point_music=process.env.NODE_ENV !== 'production'? `http://aaf-stbnagra-${(env=='test')?env:'preprod'}.clarovideo.net/webapi/`:'/webapi/';
  return {
      api_version: "v5.93",
      authpn: "amco",
      authpt: "12e4i8l6a581a",
      appKey: device_config.appKey || defaultAppKey,
      end_point_middleware,
      device_category: device_config.device_category,
      device_id: dev_id,
      device_manufacturer: device_config.device_manufacturer,
      device_model: device_config.device_model,
      device_name: device_config.device_name,
      device_so: device_config.device_so,
      device_type: device_config.device_type,
      region: "",
      format: "json",
      osversion: "2.0",
      akamai:{
          xml: 'var AKAMAI_MEDIA_ANALYTICS_CONFIG_FILE_PATH = "{URL}";',
          url: '//79423.analytics.edgesuite.net/js/csma.js',
      },
      api_errors: {
          format: {
              text: 'api_error_format'
          }
      },
      UniqueID:getDeviceID(),
      end_point_music: musicMiddlewareEndpoint,
      appversion: device_config.appversion,
      firmwareversion: device_config.firmwareversion,
      xdk_redirect: '/xdkredirect/',
      api_music_endpoint: process.env.API_MUSIC_ENDPOINT || 'http://api.claromusica.com',
      music_app_id: 'ad19455c0c46081645044646d22b8ed2',
      music_app_version: '773de36f0db57e49010eff788bde4afb',
    }
}

export default getAppConfig;



// WEBPACK FOOTER //
// ./src/config/appConfig.js